<template>
  <div class="flex flex-1 justify-center">
    <user-home />

  </div>
</template>

<script setup lang="ts">
import UserHome from '../components/Home/UserHome.vue';
</script>
